module.exports = __webpack_public_path__ + "e24a79740e8d63d2420d1713dbe970c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/forgotPass.png
// module id = 1082
// module chunks = 0